/** Same-origin app font policy. Unknown choices never initiate a font request. */
const LOCAL_FONTS: Record<string, string> = {
  Inter: '"Inter", ui-sans-serif, system-ui, sans-serif',
  Orbitron: '"Orbitron", ui-sans-serif, system-ui, sans-serif',
  Literata: '"Literata", ui-serif, Georgia, serif',
};

export function localFontStack(requested: unknown): string {
  return typeof requested === "string" && Object.prototype.hasOwnProperty.call(LOCAL_FONTS, requested)
    ? LOCAL_FONTS[requested]
    : LOCAL_FONTS.Inter;
}

export function applyLocalAppFont(root: HTMLElement, doc: Document, requested: unknown): void {
  doc.querySelectorAll('link[data-font="custom"]').forEach(link => link.remove());
  root.style.setProperty("--font-sans", localFontStack(requested));
}
